<span class="p-badge-no-gutter">
  <p-badge
    [value]="value()"
    [badgeSize]="size()"
    [badgeDisabled]="disabled()"
    [styleClass]="'severity-' + severityClass() + ' ' + (round() ? 'round' : 'radius-default')" />
</span>
